'use strict';

import { Entity } from '../Entity';

export class UserSetting extends Entity {
  protected auto;

  protected userId;

  protected settingLogoutTimer;

  protected settingSecurityPin;

  protected settingPendingUpdate;

  protected settingDashboardView;

  protected settingActivitiesReport;

  protected settingAlertText;

  protected settingAlertNumber;

  protected settingTheme;

  protected themeNav;

  protected settingStaffQuota;

  protected settingStaffCount;

  protected biLingual;

  protected settingNoteFormat;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.auto = data.auto;

    this.userId = data.userId;

    this.settingLogoutTimer = data.settingLogoutTimer;

    this.settingSecurityPin = data.settingSecurityPin;

    this.settingPendingUpdate = data.settingPendingUpdate;

    this.settingDashboardView = data.settingDashboardView;

    this.settingActivitiesReport = data.settingActivitiesReport;

    this.settingAlertText = data.settingAlertText;

    this.settingAlertNumber = data.settingAlertNumber;

    this.settingTheme = data.settingTheme;

    this.themeNav = data.themeNav;

    this.settingStaffQuota = data.settingStaffQuota;

    this.settingStaffCount = data.settingStaffCount;

    this.biLingual = data.biLingual;

    this.settingNoteFormat = data.settingNoteFormat;
  }

  public getAuto() {
    return this.auto;
  }

  public setAuto(auto) {
    this.auto = auto;

    return this;
  }

  public getUserId() {
    return this.userId;
  }

  public setUserId(userId) {
    this.userId = userId;

    return this;
  }

  public getSettingLogoutTimer() {
    return this.settingLogoutTimer;
  }

  public setSettingLogoutTimer(settingLogoutTimer) {
    this.settingLogoutTimer = settingLogoutTimer;

    return this;
  }

  public getSettingSecurityPin() {
    return this.settingSecurityPin;
  }

  public setSettingSecurityPin(settingSecurityPin) {
    this.settingSecurityPin = settingSecurityPin;

    return this;
  }

  public getSettingPendingUpdate() {
    return this.settingPendingUpdate;
  }

  public setSettingPendingUpdate(settingPendingUpdate) {
    this.settingPendingUpdate = settingPendingUpdate;

    return this;
  }

  public getSettingDashboardView() {
    return this.settingDashboardView;
  }

  public setSettingDashboardView(settingDashboardView) {
    this.settingDashboardView = settingDashboardView;

    return this;
  }

  public getSettingActivitiesReport() {
    return this.settingActivitiesReport;
  }

  public setSettingActivitiesReport(settingActivitiesReport) {
    this.settingActivitiesReport = settingActivitiesReport;

    return this;
  }

  public getSettingAlertText() {
    return this.settingAlertText;
  }

  public setSettingAlertText(settingAlertText) {
    this.settingAlertText = settingAlertText;

    return this;
  }

  public getSettingAlertNumber() {
    return this.settingAlertNumber;
  }

  public setSettingAlertNumber(settingAlertNumber) {
    this.settingAlertNumber = settingAlertNumber;

    return this;
  }

  public getSettingTheme() {
    return this.settingTheme;
  }

  public setSettingTheme(settingTheme) {
    this.settingTheme = settingTheme;

    return this;
  }

  public getThemeNav() {
    return this.themeNav;
  }

  public setThemeNav(themeNav) {
    this.themeNav = themeNav;

    return this;
  }

  public getSettingStaffQuota() {
    return this.settingStaffQuota;
  }

  public setSettingStaffQuota(settingStaffQuota) {
    this.settingStaffQuota = settingStaffQuota;

    return this;
  }

  public getSettingStaffCount() {
    return this.settingStaffCount;
  }

  public setSettingStaffCount(settingStaffCount) {
    this.settingStaffCount = settingStaffCount;

    return this;
  }

  public getBiLingual() {
    return this.biLingual;
  }

  public setBiLingual(biLingual) {
    this.biLingual = biLingual;

    return this;
  }

  public getSettingNoteFormat() {
    return this.settingNoteFormat;
  }

  public setSettingNoteFormat(settingNoteFormat) {
    this.settingNoteFormat = settingNoteFormat;

    return this;
  }
}
